import { User } from 'microsoft-graph';
import { IDynamicPerson, Person } from '@microsoft/mgt-react';
import { useGraphService } from '@repo/services';
import { useAsyncEffect, useLocalStorageState } from '@repo/utils';
import React, { useEffect } from 'react';
import { useMantineColorScheme, useMantineTheme } from '@mantine/core';
import { applyTheme } from '@microsoft/mgt-components';

/**
 * A component that displays a person's details (avatar, name, email) fetched from Microsoft Graph by their email address, with local cache persistence and theme-aware styling.
 */
export const PersonByEmail = ({
  email,
  fallbackDetails,
  ...props
}: {
  email: string;
  fallbackDetails?: IDynamicPerson;
}) => {
  const { colorScheme } = useMantineColorScheme();

  const { getUser } = useGraphService();
  // @ts-ignore
  const [userDetails, setUser] = useLocalStorageState<User>(`graph-user:${email}`);

  const getUserAction = async () => {
    try {
      const { user } = await getUser(email, false);
      setUser(user);
    } catch (e) {
      console.warn(e);
    }
  };
  useEffect(() => {
    applyTheme(colorScheme === 'dark' ? 'dark' : 'light');
  }, [colorScheme]);

  useAsyncEffect(async () => {
    if (!userDetails) await getUserAction();
  }, [email, userDetails]);

  if (!email) return null;

  return (
    <Person
      // templateRendered={console.log}
      {...props}
      fallbackDetails={fallbackDetails}
      // @ts-ignore
      userId={userDetails?.id}
    />
  );
};
